<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Terms and Use Agreement</h1>
        </div>
        <div>
            <h3 class="mb-0">Conditions of Sale/Terms and Use Agreement</h3>
            <h2 class="mt-0 mb-0">
                What if I am not satisfied with my order? <br />The MyCorwin
                Three Day Guarantee of Satisfaction:
            </h2>
            <h3 class="mt-0">
                You must let us know within three (3) business days of receipt
                if there is an issue with your order
            </h3>
            <p>
                Corwin stands behind the timeliness and quality of its products
                and services. If you are not 100% satisfied with your purchase
                from us (your fault or ours), simply contact our customer
                service department within three (3) business days from the date
                you receive it (or the date it was scheduled to arrive) and we
                will reprint your calendar(s) and/or newsletter(s) immediately.
                All jobs will be shipped UPS Ground unless you prefer and pay
                for overnight shipping. All overnight shipping is billed
                directly to client’s shipper account.
            </p>
            <p>
                If the error was not made at Corwin and you need your job
                reprinted, contact our customer service department and you will
                be instructed on the best method to have your job redone. At
                your written request, Corwin will reprint your job immediately
                at a reduced price and ship it immediately. On your invoice, you
                will see your regular prices for your ordered products PLUS the
                reduced price for reprinting your job(s).
            </p>
            <p>
                For errors made by Corwin, we will need the entire order sent
                back to Corwin in its original packaging via UPS – otherwise
                shipping and processing fees will be charged to your account.
                While your package is being returned to Corwin, in good faith,
                we will reprint your job and ship it immediately while we await
                your returned package. Upon arrival of your returned package, we
                will reprint the product(s) in question, excluding shipping and
                processing costs. Please note: if you receive a box of calendars
                and/or newsletters and a tube of oversize calendar posters and
                only one item is incorrect, only return the box of incorrect
                items (i.e.: box of calendars are correct but the oversize
                calendar posters is the wrong size – send back only the oversize
                calendar poster tube).
            </p>
            <p>
                For jobs damaged during shipping, the original package and all
                of it’s contents must be saved at your facility for our shipper
                to pick it up. Contact our customer service department
                immediately, or within three (3) business days, and let us know
                the severity of the damage. We will file a claim with our
                shipper so Corwin gets proper credit for the damaged package and
                reprinting your job(s). We will reprint your damaged order and
                ship it overnight at no expense to you. IMPORTANT! You must save
                the damaged package until the shipper picks it up for proper
                credit – otherwise, you will be charged for a complete order
                plus overnight shipping (if applicable).Corwin takes great pride
                in its commitment to customer satisfaction. However, certain
                circumstances are beyond our control and are not covered by the
                guarantee. Please note that we cannot be responsible for:•
                Spelling, punctuation or grammatical errors made by the
                customer.• Verbal corrections given to Corwin by the customer.•
                Errors in user-selected options such as choice of paper color,
                poster size, quantity or product type.• Damage to the products
                arising after delivery to the customer.• Products missing after
                proof of delivery by shipping provider.
            </p>
            <p>
                Please preview your designs carefully and correct any mistakes
                prior to placing your order. In an effort to keep costs down and
                pass substantial savings along to our customers, Corwin nor
                Corwin Design & Graphics Corporation does not proof documents
                created by its customers prior to processing.
            </p>
            <h2 class="mb-0">
                The plain and simple things: A thought about Copyright
                Infringement (The Hall of Shame)
            </h2>
            <h3 class="mt-10">
                READ THIS BEFORE YOU CONSIDER TAKING ARTWORK FROM CORWIN TO YOUR
                LOCAL COPY CENTER:
            </h3>
            <p>
                Under copyright law and the method in which Corwin will legally
                enforce it, you cannot utilize an outside service to duplicate
                your calendar or enlarge it to poster size. You are able to make
                your own 8.5 x 11 or 11 x 17 copies inside your facility on your
                facility copy machine. Use of any outside copy service for
                copies or posters is copyright infringement.Corwin maintains a
                high quality service that we must provide for our clients. Our
                intention is that all of our clients have their artwork printed
                by Corwin so that all steps in maintaining the highest quality
                are taken. We copyright our templates because we created them
                for the sole purpose of providing a high-end activity calendar
                for the activity profession. When our artwork is printed by
                another service, our name is on every calendar which may not
                live up to our high printing standards. Our legal department
                works diligently to copyright our templates and will go to the
                fullest extend of the law to crack down on people who copy our
                artwork outside the facility level.If you wish to purchase your
                calendar and own the entire artwork, including the templates
                created by Corwin, there is a fee of $75.00 that will be billed
                monthly to your account and the copyright indicia will be
                removed from your calendar. The condition in which you can use
                that artwork is restricted to making copies or enlargements at
                your local copy center – you do not own the template.
            </p>
            <p>
                Did you know that there are actually companies who are thinking
                of using our artwork, templates and other content on
                MyCorwin.com, MyCorwinCalendar.com, MyCorwinOnline.com, and
                other Corwin Design & Graphics Corporation’s subsidiaries
                without our permission? We sincerely hope you’re not one of
                them, but if you are thinking of copying our artwork, templates
                or other content and using them, or “sharing” your subscription
                with another, or reprinting them in your print publication
                without permission…we encourage you to please think again.
            </p>
            <p>
                Much time, effort and research goes into creating our site and
                once published, our site and every single calendar template,
                artwork, and navigational tools, articles, etc. that has been
                created by us, is protected by Copyright Law. There are many
                people who aren’t familiar with Internet Copyright Law – then
                there are those who are familiar with it, and just choose to
                ignore it. Please do not reproduce our copyrighted information,
                or reprint them in any other media without permission. If you
                have reproduced any of our calendars or copied any of our
                copyrighted works, you will eventually be found, and appropriate
                procedures will be followed to the fullest extent of the law. We
                respond to each and every incident of copyright infringement and
                report them as such. If a satisfactory solution is not reached
                within one month’s time, we reserve the right to list your
                infringement here, along with your domain and link to the
                infringing page. Copyright infringement is against the law — we
                thank you for respecting and supporting Internet Copyright Law,
                and the original works of website owners.
            </p>
            <p>Please help us by reporting a copyright incident.</p>
            <h2>E-mails</h2>
            <p>
                We are not responsible for lost or mis-directed e-mails. If our
                mail server is down or your mail program rejects mail from us,
                we have no way of knowing that you sent an email or you did not
                receive our email to you. Please check all spam settings on your
                e-mail client and insure that you are open to receiving mail
                from us. In the event our hosting server has a problem and is
                down and e-mails are lost, we cannot accept responsibility.
                Please be sure your email address is put in the shopping cart
                accurately. If your email address bounces from the shopping
                cart, we cannot fill your order and will not be able to contact
                you.
            </p>
            <p>
                There are times that our production takes place late at night
                which does not lend to calling customers. E-mail is our
                preferred source of communication.
            </p>
            <h2>Production Time</h2>
            <p>
                Our goal is to produce your calendar and have it delivered to
                you on or before the first of the month. All orders are produced
                in the order they were received. Most items produced at our
                facility are printed and shipped within seven (7) business days,
                not including holidays or weekends; however, this is an estimate
                and may take longer especially during heavy volume time,
                Holidays, Weather conditions that may prevent us from working
                (i.e.: tropical storms and hurricanes), etc.. Any custom design
                requests may take longer.
            </p>
            <p>
                If you need your order by the end of the month, we strongly
                recommend that you place your order in its entirety by the 15th
                of the month. If you need your order by a certain date that is
                before the end of the month, please make sure to tell us and we
                will make every effort to meet your deadline!
            </p>
            <h2>Shipping</h2>
            <p>
                Your order will be shipped via UPS Ground service and billed to
                your Corwin account unless overnight service is requested and
                paid for by your facility. You will be required to send us your
                preferred shipper of choice and account number to be billed
                directly to your account with that shipper. We will prepare and
                ship your order with your requested shipper. A nominal handling
                fee will be added to your order for boxing, taping and calling
                for pick up of your order with your appropriate shipper.
                Incomplete or inaccurate shipper account numbers will delay your
                shipment. Corwin is not responsible for verifying the accuracy
                of your shipper account number and any order billed to Corwin’s
                shipping accounts with FedEx, DHL and UPS Overnight because of
                client error (inactive, on hold or wrong shipper account number)
                will be billed and due immediately by the client and any future
                orders with the same expectation of overnight delivery must be
                corrected with an accurate account number. Corwin has the right
                to refuse overnight delivery charges on our account which will
                delay your order. Please double check your account number and
                status with your shipper before placing your order with Corwin.
            </p>
            <h2>Communication & Changes to your order</h2>
            <p>
                It is important that you check your e-mail on a regular basis.
                We may send questions pertaining to your order and a delay in
                your response to us is a delay in production of your order. If
                you would like to make additional changes to your order after it
                has been submitted, contact Corwin via email to determine if it
                has been produced. If it has not been produced, Corwin will
                release your order back to you to edit. IMPORTANT: IF YOUR ORDER
                IS CANCELLED AT CORWIN SO YOU CAN EDIT YOUR CALENDAR – WE DO NOT
                HAVE THAT ORDER UNTIL YOU RESEND IT TO US – IN ITS ENTIRETY. Do
                not send partial orders. We prefer all correspondence be made
                via e-mail so there is a record for review and less errors
                happen that way. However, please try to keep your emails precise
                and to a minimum. We request you attempt to give the most
                accurate info during the order process
            </p>
            <h2>
                The Legal Stuff: <br />
                Terms and Use Agreement
            </h2>
            <p>
                This Agreement is an agreement between you, the paid subscriber
                (“User”) and MyCorwin.com (“Corwin”) for use of the web-based
                applications known as www.MyCorwinCalendar.com,
                www.MyCorwinOnline.com, www.MyCorwin.com, and related resource
                and services (collectively “Corwin Design & Graphics Corporation
                Services”). Please read and understand this User Agreement.
            </p>
            <h3>1. GRANT OF LICENSE</h3>
            <p>
                Subject to the terms of this User Agreement, Corwin hereby
                grants to User a worldwide, non-transferable, nonexclusive
                license to use Corwin Design & Graphics Corporation’s Services,
                for the term of this User Agreement, in connection with
                providing subscription style calendar and newsletter services
                for User’s facility use (Facility would be defined as the place
                of employment of User). Sharing between facilities is
                prohibited. This User Agreement does not grant User any title or
                right of ownership in Corwin Services.
            </p>
            <h3>2. TERM</h3>
            <p>
                This User Agreement shall become effective when User accesses
                Corwin Services, and shall continue in effect until terminated
                as provided in Section 6.2 below. Upon termination of this User
                Agreement, the license granted by Corwin to User hereunder shall
                immediately terminate. User shall cease using Corwin Services
                immediately upon the termination of this User Agreement.
            </p>
            <h3>3. HARDWARE AND THIRD PARTY SOFTWARE AND SERVICES</h3>
            <p>
                The User has the sole responsibility to obtain and properly
                configure appropriate hardware and software necessary to use
                Corwin Services, and to obtain a connection to Corwin Services
                over the Internet.
            </p>
            <h3>4. INTELLECTUAL PROPERTY RIGHTS AND RESTRICTED USE</h3>
            <p>
                4.1 Corwin Rights. User acknowledges Corwin is the sole owner of
                Corwin Services and, except as expressly permitted herein, has
                the sole right to grant licenses to Corwin Services . User
                acknowledges that Corwin Services constitutes valuable
                confidential information and trade secrets, proprietary to
                Corwin. User acknowledges that the Corwin Services web site, as
                well as proprietary rights in and appurtenant to Corwin
                Services, including without limitation to copyright, patent, and
                trade secret rights, are and shall remain the sole property of
                Corwin. User shall have only the limited use rights specifically
                granted by this User. Any rights not expressly granted in this
                User Agreement are expressly reserved.
            </p>
            <p>
                4.2 Copyright and other information. User shall use reasonable
                efforts to display all Corwin copyright, trademark, and other
                proprietary notices and disclaimers. User shall not alter,
                remove, or conceal any copyright, trademark, or other
                proprietary notice or disclaimer.
            </p>
            <p>
                4.3 No De-compilation or Modification. User shall not modify
                copy, translate, or otherwise prepare derivative works, reverse
                engineer, disassemble, de-compile, recreate, or generate any of
                Corwin Services or portion thereof, except to the extent Corwin
                has authorized User to use Corwin Services contrary to this
                section pursuant to a separate written agreement.
            </p>
            <p>
                4.4 No Transfer. User shall not, in whole or in part, rent,
                lease, sublicense, sell, assign, or otherwise transfer Corwin
                Services, any component or portion thereof or any document
                produced there from.
            </p>
            <p>
                4.5 Confidentiality. Except as expressly provided in Section 1
                of this User Agreement, User shall not use, give permission in
                connection with the use of, copy, disclose, or make available,
                directly or indirectly, all or any portion of Corwin Services or
                related documentation to any person.
            </p>
            <p>
                4.6 Security. User agrees that the Corwin Services are intended
                for the sole use of the User. User is responsible for
                maintaining the security and confidentiality of User’s password.
                USER SHALL NOT SHARE USER’S PASSWORD WITH ANYONE. If you know or
                suspect that the password has been compromised, you should
                change your password immediately and contact us via the form at
                the bottom of this page or via email.
            </p>
            <h3>5. PAYMENT</h3>
            <p>
                5.1 To the extent that Corwin makes available free or discounted
                introductory trial memberships to Corwin Services, users shall
                not accept more than a single such offer without the permission
                of Corwin. Accepting more than a single such offer, whether by
                utilizing a false identity or by providing Corwin with false or
                misleading registration information, or by using any other means
                or circumstance, shall result in a termination of this User
                Agreement.
            </p>
            <p>
                5.2 Users who subscribe to Corwin’s services (“Subscriber”) have
                paid or shall pay for the license and access to Corwin’s
                services, and/or the provision of any services provided by
                Corwin, or such other fees as are mutually agreed upon by the
                parties for such license, access and/or services. The charges
                for the license granted and/or services provided by Corwin are
                exclusive of any and all taxes, levies, duties, import and
                export charges, or any other form of taxation properly
                chargeable with respect to this User Agreement. Any taxes,
                levies, duties, import and export charges, and fees due pursuant
                to other forms of taxation will be the responsibility of
                Subscriber.
            </p>
            <p>
                5.3 Except where explicitly stated, Corwin Services are licensed
                on either a month to month basis or an annual basis and are
                automatically renewed at the then current month to month or
                annual rate.
            </p>
            <p>
                5.4 Payment is due upon receipt, unless otherwise stated. A 1.5
                percent monthly service charge is payable on all overdue
                balances after 30 days. In the event of non-payment of an
                invoice and/or if any dispute arises in regard to this
                agreement, MyCorwinCalendar.com and/or its parent company,
                Corwin Design & Graphics Corporation, has the sole right to
                either submit same to binding arbitration, in accordance with
                the rules of the American Arbitration Association or to any
                appropriate court of law. IN any case, Client shall pay all
                costs of collection, arbitration, and/or court costs, plus
                reasonable attorney’s fees plus interest at maximum rate
                allowable by law from date of invoice or award, whichever occurs
                first.
            </p>
            <p>
                5.5 Failure to pay subscription fees and all monies owed to
                Corwin will place client on credit hold until payment is
                received in full. Clients on credit hold will not have access to
                subscription service online until all payments are received in
                full.
            </p>
            <h3>6. TERMINATION / RENEWAL</h3>
            <p>
                6.1 If any fee to be paid by Subscriber for the rights and
                license granted herein is past due, Corwin may terminate this
                User Agreement and the license granted hereunder without prior
                notice. Corwin in its sole and absolute discretion, without
                prior notice, may terminate this User Agreement and the license
                granted hereunder if User or Subscriber shall fail to comply
                with any obligation under this User Agreement or any other
                agreement between such User or Subscriber and Corwin, including
                without limitation, a breach of any restrictions on the use of
                Corwin Services or any other intellectual property licensed to
                User or Subscriber, any other infringement of the intellectual
                property rights of Corwin, or if any representation of User or
                Subscriber shall be inaccurate, or if any warranty of User or
                Subscriber shall be breached. If User or Subscriber in any way
                infringes the intellectual property rights of Corwin, Corwin may
                also, in its sole and absolute discretion, without prior notice,
                terminate any other agreement between User or Subscriber and
                Corwin.
            </p>
            <p>
                6.2 Subscriber may terminate the agreement on 30 days notice
                prior to the end of the then existing month to month or the
                annual term. In the event of cancellation of this service, a
                cancellation fee for work completed, based on the contract price
                and expenses already incurred by Corwin plus cost of commitments
                made to suppliers on behalf of the Client shall be paid by the
                Client.
            </p>
            <p>
                6.3 In addition, Corwin may terminate this User Agreement, with
                or without cause, at any time on 30 days prior notice. If such
                termination is without cause, a pro-rated refund of the
                subscription fee will be paid to Subscriber. All obligations
                relating to non-use and nondisclosure and any other applicable
                provisions, shall survive termination of this User Agreement.
            </p>
            <h3>7. EXCEPTIONS FOR VARIOUS TYPES OF SUBSCRIBERS; OTHER USERS</h3>
            <p>
                If your access to Corwin Services is provided by, or through an
                entity, such as your parent corporation (“Corporation”), with
                whom Corwin has a preexisting agreement some or all of the “Fees
                and Payments” and “Renewal” terms may not apply to you. Please
                contact your Corporate office for details.
            </p>
            <h3>8. DISCLAIMER OF WARRANTY; LIMITATION OF LIABILITY</h3>
            <p>
                USER EXPRESSLY AGREES THAT THE USE OF CORWIN SERVICES IS AT
                USER’S SOLE RISK. CORWIN SERVICES IS PROVIDED “AS IS” AND “AS
                AVAILABLE” FOR USER’S USE, WITHOUT WARRANTIES, REPRESENTATIONS
                OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED, OTHER THAN
                THE WARRANTY WHICH IS EXPRESSLY SET FORTH IN SECTION 9.1 OF THIS
                USER AGREEMENT BELOW, INCLUDING WITHOUT LIMITATION WARRANTIES OF
                FITNESS FOR A PARTICULAR PURPOSE, OF OPERABILITY, OF CONFORMANCE
                TO PUBLISHED SPECIFICATIONS, NON-INFRINGEMENT, TITLE OR OF
                MERCHANTABILITY. LICENSEE ACKNOWLEDGES THAT CORWIN SERVICES MAY
                BE MODIFIED OR MADE UNAVAILABLE AT CORWIN’S DISCRETION, AND THAT
                IN THE CASE OF A MODIFICATION TO CORWIN SERVICES , SUCH MODIFIED
                CORWIN SERVICES MAY NOT BE COMPATIBLE WITH OTHER INFORMATION
                CREATED USING A PRIOR VERSION OF CORWIN SERVICES , AND THEREFORE
                MAY NOT BE ACCESSIBLE VIA USE OF THE MODIFIED VERSION. CORWIN
                DOES NOT GUARANTEE THAT CORWIN SERVICES WILL BE AVAILABLE FOR
                USE AT THE TIMES OR LOCATIONS OF USER’S CHOOSING. THE ENTIRE
                LIABILITY OF CORWIN AND USER’S EXCLUSIVE REMEDY WITH RESPECT TO
                THE USE OF CORWIN SERVICES SHALL BE THE RECOVERY OF DIRECT
                DAMAGES, IN AN AMOUNT NOT TO EXCEED THE AMOUNT OF ANY FEE PAID
                FOR THE MATERIAL OR SERVICE CAUSING SUCH DAMAGE. IN NO CASE
                SHALL CORWIN BE LIABLE FOR LOST OR CORRUPTED DATA, LOST PROFITS,
                OR ANY OTHER INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, EXEMPLARY,
                OR CONSEQUENTIAL DAMAGES OF ANY DESCRIPTION ARISING FROM THE USE
                BY USER OF CORWIN SERVICES, FOR ANY OTHER CLAIM RELATED IN ANY
                WAY TO USER’S USE OF CORWIN SERVICES, OR ARISING FROM ANY OTHER
                MATTER RELATING TO THIS USER AGREEMENT, EVEN IF CORWIN HAS BEEN
                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. BECAUSE SOME STATES
                OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF WARRANTIES OR THE
                EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR
                INCIDENTAL DAMAGES, IN SUCH STATES OR JURISDICTIONS, THE
                WARRANTIES SHALL BE EXCLUDED AND THE LIABILITY OF CORWIN SHALL
                BE LIMITED TO THE EXTENT PERMITTED BY LAW.
            </p>
            <h3>9. REPRESENTATIONS AND WARRANTIES</h3>
            <p>
                9.1 Representations and Warranties of Corwin. Corwin represents
                and warrants that it has the right to grant the licenses herein
                granted to User, and that, to its knowledge Corwin Services and
                the exercise by User of the rights herein granted shall not
                infringe any copyright, patent, or trade secret of any third
                party.
            </p>
            <p>
                9.2 Representations and Warranties of User. User represents and
                warrants to Corwin that User is a qualified professional and
                that User has all required licenses to engage in these services,
                and that User’s use of Corwin Services will be represented
                accurately and used in compliance with all applicable laws and
                regulations.
            </p>
            <p>
                9.3 Indemnification. User shall defend, indemnify, and hold
                harmless Corwin, and Corwin’s employees, officers, directors,
                shareholders, and agents, from and against any and all claims,
                suits, loss, damages, cost or expense (including without
                limitation attorneys’ fees) resulting from any breach or alleged
                breach of any covenant, representation, or warranty in this User
                Agreement or relating or arising in any way out of any services
                or advice alleged to have been rendered or not rendered by or on
                behalf of User to any third party.
            </p>
            <p>
                9.4 MyCorwin.com, MyCorwinCalendar.com, MyCorwinOnline.com, and
                it’s parent company, Corwin Design & Graphics Corporation agrees
                to exercise its best judgment in the preparation and/or placing
                of all publications, advertising and publicity for the Client,
                with a view of avoiding any claims, proceedings, or suits being
                made and instituted against the Client or Corwin. It is mutually
                agreed, however, that the Client will indemnify Corwin against
                any loss incurred as the result of any claim, suit or proceeding
                made or brought against Corwin based upon any calendar,
                publication, advertising or publicity prepared by Corwin for the
                Client and which Client approved before its publication.
            </p>
            <p>
                Client will indemnify Corwin against any loss sustained and
                agrees to defend Corwin, as a result of any claim, suit or
                proceeding made or brought against Corwin based upon:
            </p>
            <p>
                a) Assertions made for any of Client’s products (or services) or
                any of the products (or services) of any of your competitors in
                any publications or advertising which Corwin may prepare for
                Client and which have been approved prior to publication or
                broadcast; and/or,
            </p>
            <p>
                b) A publication or advertising element which is furnished to
                Corwin by Client and which allegedly violates the personal or
                property rights of anyone,
            </p>
            <p>
                c) Claims of logo or copy duplication. The Client is responsible
                for trademark and copyright search and filing unless otherwise
                contracted to Corwin.
            </p>
            <h3>10. NO ASSIGNMENT</h3>
            <p>
                User may not assign or otherwise transfer any of its rights,
                duties, or obligations under this User Agreement, without the
                prior written consent of Corwin.
            </p>
            <h3>11. GOVERNING LAW AND JURISDICTION</h3>
            <p>
                Corwin Services is controlled by Corwin from its offices within
                the state of Florida, United States of America. By accessing
                Corwin Services, User and Corwin agree that all matters relating
                to User’s access or use of Corwin Services shall be governed by
                the statutes and laws of the State of Florida, without regard to
                the conflicts of laws principles thereof.
            </p>
            <h3>12. NOTICES</h3>
            <p>
                All notices, requests, demands, and other communications called
                for or contemplated hereunder shall be in writing and shall be
                deemed to have been duly given when delivered or three (3) days
                after mailing by U.S. certified mail, return receipt requested,
                postage prepaid (unless other mode(s) of delivery are
                specified), at such addresses as the parties may designate by
                written notice.
            </p>
            <h3>13. ENTIRE AGREEMENT</h3>
            <p>
                This User Agreement constitutes the entire understanding and
                agreement between Corwin and User regarding the terms and
                conditions of the licensing of Corwin Services.
            </p>
            <h3>14. NONWAIVER AND SEVERABILITY</h3>
            <p>
                Corwin’s failure to exercise any right or provision of this User
                Agreement shall not constitute a waiver of such right or
                provision. If a court of competent jurisdiction holds any
                provision of this User Agreement to be invalid, the parties
                nevertheless agree that the court should endeavor to give effect
                to the parties’ intentions as reflected in the provision, and
                agree that the other provisions of this User Agreement remain in
                full force and effect. In the event that any provision hereof is
                found invalid or unenforceable pursuant to judicial decree or
                decision, the remainder of this User Agreement shall remain
                valid and enforceable according to its terms.
            </p>
            <p>© 2019 Corwin Design & Graphics Corporation</p>
        </div>
    </vue-scroll>
</template>

<script>
export default {
    name: "terms"
};
</script>

<style scoped></style>
